import * as firebase from "firebase/app";
import "firebase/auth";
import "firebase/database";

const config = {
  apiKey: "AIzaSyCDWGB1fXcA2kZNszNdTB_S2ojXLJSwtKg",
  authDomain: "react-app-e601c.firebaseapp.com",
  databaseURL: "https://react-app-e601c.firebaseio.com",
  projectId: "react-app-e601c",
  storageBucket: "react-app-e601c.appspot.com",
  messagingSenderId: "795414432503",
  appId: "1:795414432503:web:79070a5bd71f139c36a1f2",
};

firebase.initializeApp(config);

export default firebase;
